import { SIDEBAR_LUCIDE_STROKE } from '@/components/ui/sidebarExpandState'

/**
 * Shared Lucide icon sizing for the main sidebar nav (section links,
 * footer Slack). Keeps stroke and box size consistent across the column.
 */
export const NAV_LUCIDE_SIZE_CLASS = 'size-4 shrink-0' as const

/** Aligned with the sidebar pin/toggle; Slack uses the same value */
export const NAV_LUCIDE_STROKE = SIDEBAR_LUCIDE_STROKE
